import { BasicModal } from '@shared/Widgets/Modals/BasicModal/BasicModal';
import css from './ItemsSelectionModal.module.css';
import { ItemsSelectionModalFooter } from '@modules/Steps/Shared/Widgets/Modals/ItemsSelectionModal/ItemsSelectionModalFooter/ItemsSelectionModalFooter';
import { ItemsSelectionModalHeader } from '@modules/Steps/Shared/Widgets/Modals/ItemsSelectionModal/ItemsSelectionModalHeader/ItemsSelectionModalHeader';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { ItemForSelect } from '@modules/Steps/Shared/Widgets/Modals/ItemsSelectionModal/ItemForSelect/ItemForSelect';
import { useProjectStore } from '../../../../../../Stores/ProjectStore';
import React, { useEffect, useState } from 'react';
import { SortParamEnum, SortParamType } from '@shared/Enums/SortParamEnum';
import { BasicLoader } from '@shared/Ui/Loaders/BasicLoader/BasicLoader';
import { ItemTypeViewModel } from '@viewModels/ItemTypeViewModel/ItemTypeViewModel';
import { useItemTypeStore } from '../../../../../../Stores/ItemTypeStore';

interface ItemsSelectionModalProps {
    onClose: () => void;
    itemType: ItemTypeEntity;
}

export const ItemSelectionModal: React.FC<ItemsSelectionModalProps> = ({
    onClose,
    itemType,
}) => {
    const { isItemsLoading, itemsData } = useItemTypeStore();
    const { customProject } = useProjectStore();
    const itemTypeViewModel = new ItemTypeViewModel();

    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [sortOrder, setSortOrder] = useState<SortParamType>(
        SortParamEnum.ASC
    );

    const handleChangeSortOrder = (sortBy: SortParamType) =>
        void setSortOrder(sortBy);
    const handleChangeSearch = (search: string) => void setSearch(search);

    const handleChangePage = (page: number) => void setPage(page);
    const itemsPerPage = window.innerHeight < 850 ? 3 : 4;
    const isFillDisabled =
        itemTypeViewModel.calculateTotalQuantityFromItemType(itemType) >=
        itemType.qty;

    useEffect(() => {
        const fetchData = async () => {
            await itemTypeViewModel.fetchItemType({
                itemType: itemType,
                page: page,
                perPage: itemsPerPage,
                search,
                sortOrder,
                projectStoreId: customProject.storeId,
            });
        };
        setIsInitialLoad(false);
        fetchData();
    }, [page, search, sortOrder]);

    const handleConfirmSelection = () => {
        itemTypeViewModel.updateItemTypeItems(itemType);
        onClose();
    };

    if (isItemsLoading && isInitialLoad) {
        return (
            <BasicModal onClose={onClose} extraClassName={css.modal}>
                <BasicLoader />
            </BasicModal>
        );
    } else {
        return (
            <BasicModal onClose={onClose} extraClassName={css.modal}>
                <ItemsSelectionModalHeader
                    itemType={itemType}
                    search={search}
                    changeSearch={handleChangeSearch}
                    changeSortBy={handleChangeSortOrder}
                />
                {isItemsLoading ? (
                    <BasicLoader />
                ) : itemsData.items.length === 0 ? (
                    <div className={css.noItemsMessage}>
                        No items were found
                    </div>
                ) : (
                    <ul className={css.itemsList}>
                        {itemsData.items.map((item, index) => (
                            <li key={item.uuid} className={css.item}>
                                <ItemForSelect
                                    item={item}
                                    isFillDisabled={isFillDisabled}
                                    itemType={itemType}
                                    key={index}
                                />
                            </li>
                        ))}
                    </ul>
                )}
                <ItemsSelectionModalFooter
                    handleConfirm={handleConfirmSelection}
                    changePage={handleChangePage}
                    pagination={itemsData.pagination}
                    isLoadingData={isItemsLoading}
                    disabledConfirmBtn={isItemsLoading}
                />
            </BasicModal>
        );
    }
};
